import React from "react";
import { Link } from "react-router-dom";

import PrimaryButton from "../../../components/buttons/PrimaryButton";
import LogoAxa from "../../../assets/images/axa_colpatria.png";
import LogoVaz from "../../../assets/images/vaz_seguros_logo.png";
import { IClaimsPageSponsor } from "../../../services/microservice/agents/sponsors/sponsors-service.interface";

// La aseguradora llega como texto; se resuelve a su logo.
const getInsurerLogo = (aseguradora: string): string | null => {
  const value = (aseguradora || "").toLowerCase();
  if (value.includes("axa") || value.includes("colpatria")) return LogoAxa;
  if (value.includes("vaz")) return LogoVaz;
  return null;
};

// Samsung usa su propio flujo de reclamación.
const getClaimPath = (name: string): string =>
  (name || "").toLowerCase().includes("samsung")
    ? "/samsung-care-plus/reclamaciones"
    : "/tramites-y-reclamaciones/axa";

const CardClaim = ({
  name,
  slug,
  logoUrl,
  aseguradora,
}: IClaimsPageSponsor) => {
  const insurerLogo = getInsurerLogo(aseguradora);
  const claimPath = getClaimPath(name);

  return (
    <div className="my-4 flex flex-col items-center justify-center rounded-2xl bg-white p-10 py-20 shadow-xl">
      <div
        className={`mb-10 ${
          insurerLogo
            ? "grid grid-cols-2 items-center gap-4"
            : "flex items-center justify-center"
        }`}
      >
        {insurerLogo && (
          <img
            src={insurerLogo}
            alt="aseguradora_logo"
            className="mx-auto max-h-20 object-contain"
          />
        )}
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={`${name}_logo`}
            className="mx-auto max-h-24 max-w-full object-contain"
          />
        ) : (
          <span className="text-textBlack text-2xl font-bold">{name}</span>
        )}
      </div>
      <Link to={`${claimPath}?product=${slug}`}>
        <PrimaryButton
          title="Haz Tu Reclamación"
          className="bg-buttonPrimary rounded-xl text-white"
        />
      </Link>
    </div>
  );
};

export default CardClaim;
